export default __webpack_public_path__ + "static/media/question-line.346b4f99.png";